import { apiClient } from '~/api/client'
import { useSettingsStore } from '~/stores/settings'

export const syncPushSubscriptionLanguages = async (): Promise<void> => {
  const { pushNotificationsEnabled, pushSubscriptionEndpoint, sourceLanguage, learnLanguage } =
    useSettingsStore.getState()

  const source = sourceLanguage?.value
  const learn = learnLanguage?.value

  if (!pushNotificationsEnabled || !pushSubscriptionEndpoint || !source || !learn)
    return console.warn({
      message: 'Failed to sync push subscription languages',
      pushNotificationsEnabled,
      pushSubscriptionEndpoint,
      source,
      learn,
    })

  await apiClient.POST('/push/languages', {
    body: {
      endpoint: pushSubscriptionEndpoint,
      source,
      learn,
    },
  })
}
